export const useSafeAreaInsets = () => ({
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
});
